import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Spinner, Alert, AlertIcon, useMediaQuery } from "@chakra-ui/react";
import BGLogin from "./assets/images/image_login.png";
import LogoImg from "./assets/images/Logo-PNG.png";
import OpenEyeImg from "./assets/images/open_eye.png";
import CloseEyeImg from "./assets/images/close_eye.png";
import LogoFooterImg from "./assets/images/logo_footer.png";
import SuccessIcon from "./assets/fluent_people-team-16-regular.svg";

const REGISTER_SUCCESS_MESSAGE = "Registro exitoso. Usuario pendiente de autirización por un administrador.";

function RegisterSuccessView({ message }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
      {/* Logo */}
      <div style={{ textAlign: "center", marginBottom: 45 }}>
        <img src={LogoImg} alt="Hospital Británico" style={{ maxHeight: 80, width: "auto" }} />
      </div>

      {/* Title */}
      <h1 style={{ fontWeight: 600, fontSize: 24, lineHeight: "28px", letterSpacing: "0%", textAlign: "center", color: "#004890", marginBottom: 45 }}>
        ¡Tu cuenta ha sido creada exitosamente!
      </h1>

      {/* Subtitle */}
      <p style={{ color: "#666", fontSize: 14, marginBottom: 45, textAlign: "center", maxWidth: 400 }}>
        {message || "Estaremos avisando, por si alguien te da de alta"}
      </p>

      {/* Icon */}
      <div style={{ marginBottom: 45 }}>
        <img src={SuccessIcon} alt="" style={{ width: 120, height: 120 }} />
      </div>

      {/* Ir al Home link */}
      <p style={{ color: "#666", fontSize: 14 }}>
        Ir al{" "}
        <Link to="/" style={{ color: "#06ACCD", fontWeight: "bold" }}>Home</Link>
      </p>
    </div>
  );
}

const RegisterPage = () => {
  const [providerCuit, setproviderCuit] = useState("");
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [docType, setDocType] = useState("");
  const [docNumber, setDocNumber] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [registerStatusAlert, setRegisterStatusAlert] = useState(null);
  const [registerSuccess, setRegisterSuccess] = useState(false);
  const [registerSuccessMessage, setRegisterSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showImagePanel] = useMediaQuery("(min-width: 769px)");

  const onlyLettersRegex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]+$/;

  async function register() {
    setRegisterStatusAlert(null);

    if (!providerCuit) {
      setRegisterStatusAlert(<Alert status="warning" borderRadius="5px"><AlertIcon />Ingrese el CUIT del prestador.</Alert>);
      return;
    }
    if (!name || !name.trim()) {
      setRegisterStatusAlert(<Alert status="warning" borderRadius="5px"><AlertIcon />Ingrese el nombre.</Alert>);
      return;
    }
    if (!onlyLettersRegex.test(name.trim())) {
      setRegisterStatusAlert(<Alert status="warning" borderRadius="5px"><AlertIcon />El nombre solo debe contener letras.</Alert>);
      return;
    }
    if (!lastName || !lastName.trim()) {
      setRegisterStatusAlert(<Alert status="warning" borderRadius="5px"><AlertIcon />Ingrese el apellido.</Alert>);
      return;
    }
    if (!onlyLettersRegex.test(lastName.trim())) {
      setRegisterStatusAlert(<Alert status="warning" borderRadius="5px"><AlertIcon />El apellido solo debe contener letras.</Alert>);
      return;
    }
    if (!email || !email.trim()) {
      setRegisterStatusAlert(<Alert status="warning" borderRadius="5px"><AlertIcon />Ingrese el correo electrónico.</Alert>);
      return;
    }
    if (!email.includes("@")) {
      setRegisterStatusAlert(<Alert status="warning" borderRadius="5px"><AlertIcon />Ingrese un correo electrónico válido.</Alert>);
      return;
    }
    if (password !== confirmPassword) {
      setRegisterStatusAlert(
        <Alert status="warning" borderRadius="5px">
          <AlertIcon />
          Las contraseñas no coinciden.
        </Alert>
      );
      return;
    }
    setLoading(true);
    setRegisterStatusAlert(null);
    var body = {
      providerCuit: providerCuit,
      email: email,
      name: name,
      lastName: lastName,
      docType: docType,
      docNumber: docNumber,
      password: password,
    };
    var response = await fetch("user/register", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    var jsonRes = await response.json();

    if (jsonRes.responseCode === "400" && jsonRes.message === REGISTER_SUCCESS_MESSAGE) {
      setRegisterSuccess(true);
      setRegisterSuccessMessage(jsonRes.message);
    } else if (jsonRes.error === false) {
      setRegisterSuccess(true);
      setRegisterSuccessMessage(jsonRes.message || "");
    } else {
      setRegisterStatusAlert(
        <Alert status="warning" borderRadius="5px">
          <AlertIcon />
          {jsonRes.message}
        </Alert>
      );
    }
    setLoading(false);
  }

  const inputStyle = { border: "none", outline: "none", flex: 1, minWidth: 0, fontSize: 15, color: "#333", background: "transparent", textAlign: "center", height: "100%" };
  const inputWrapperStyle = { display: "flex", alignItems: "center", border: "1px solid rgba(98, 134, 172, 0.5)", borderRadius: 8, padding: "0 16px", background: "#fff", height: 54, boxSizing: "border-box" };
  const inputContainerStyle = { width: "100%", marginBottom: 16, position: "relative" };
  const selectStyle = { border: "1px solid rgba(98, 134, 172, 0.5)", borderRadius: 8, padding: "0 16px", background: "#fff", width: "100%", height: 54, fontSize: 15, color: docType ? "#333" : "#999", textAlign: "center", appearance: "none", WebkitAppearance: "none", MozAppearance: "none", boxSizing: "border-box" };

  return (
    <div style={{ display: "flex", minHeight: "100vh", fontFamily: "Arial, sans-serif" }}>
      <style>{`
        .login-input { text-align: center; }
        .login-input::placeholder { text-align: center; color: #999; }
        .register-select { appearance: none; -webkit-appearance: none; -moz-appearance: none; background-image: none; }
        .register-btn { width: 100%; max-width: 420px; }
        .register-form-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 0 24px;
          width: 100%;
          max-width: 864px;
        }
        .register-form-col {
          max-width: 420px;
          width: 100%;
          min-width: 0;
        }
        @media (max-width: 640px) {
          .register-form-grid { grid-template-columns: 1fr; }
          .register-form-col { max-width: 100%; }
          .register-btn { max-width: 100%; }
        }
      `}</style>
      {/* Left side - Form */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-between", padding: "40px 60px", background: "#fff" }}>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", maxWidth: 900, margin: "0 auto", width: "100%", paddingTop: 60 }}>
          {registerSuccess ? (
            <RegisterSuccessView message={registerSuccessMessage} />
          ) : (
            <>
          {/* Logo */}
          <div style={{ textAlign: "center", marginBottom: 45 }}>
            <img src={LogoImg} alt="Hospital Británico" style={{ maxHeight: 80, width: "auto" }} />
          </div>

          {/* Title */}
          <h1 style={{ fontWeight: 600, fontSize: 24, lineHeight: "24px", letterSpacing: "0%", textAlign: "center", color: "#004890", marginBottom: 20 }}>Registro</h1>
          <p style={{ color: "#666", fontSize: 14, marginBottom: 30, textAlign: "center" }}>
            Si pertenece a un prestador del plan de salud, complete su registro y será aprobado a la brevedad
          </p>

          {/* Form box - two columns */}
          <div className="register-form-grid" style={{ marginBottom: 24, padding: "24px" }}>
            {/* Column 1 */}
            <div className="register-form-col" style={{ display: "flex", flexDirection: "column" }}>
              {/* Cuit input */}
              <div style={inputContainerStyle}>
                <div style={inputWrapperStyle}>
                  <input
                    className="login-input"
                    type="text"
                    placeholder="Cuit del prestador"
                    value={providerCuit}
                    onChange={(e) => setproviderCuit(e.target.value)}
                    style={inputStyle}
                  />
                </div>
              </div>

              {/* Nombre input */}
              <div style={inputContainerStyle}>
                <div style={inputWrapperStyle}>
                  <input
                    className="login-input"
                    type="text"
                    placeholder="Nombre"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    style={inputStyle}
                  />
                </div>
              </div>

              {/* Tipo Documento select */}
              <div style={inputContainerStyle}>
                <select
                  className="register-select"
                  value={docType}
                  onChange={(e) => setDocType(e.target.value)}
                  style={selectStyle}
                >
                  <option value="">Tipo Documento</option>
                  <option value="DN">DNI</option>
                  <option value="PA">Pasaporte</option>
                </select>
              </div>

              {/* Password input */}
              <div style={inputContainerStyle}>
                <div style={inputWrapperStyle}>
                  <input
                    className="login-input"
                    type={showPassword ? "text" : "password"}
                    placeholder="Contraseña"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    style={inputStyle}
                  />
                  {showPassword ? (
                    <img src={OpenEyeImg} alt="Ocultar contraseña" style={{ width: 20, height: 20, cursor: "pointer", flexShrink: 0 }} onClick={() => setShowPassword(false)} />
                  ) : (
                    <img src={CloseEyeImg} alt="Mostrar contraseña" style={{ width: 20, height: 20, cursor: "pointer", flexShrink: 0 }} onClick={() => setShowPassword(true)} />
                  )}
                </div>
              </div>
            </div>

            {/* Column 2 */}
            <div className="register-form-col" style={{ display: "flex", flexDirection: "column" }}>
              {/* Email input */}
              <div style={inputContainerStyle}>
                <div style={inputWrapperStyle}>
                  <input
                    className="login-input"
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    style={inputStyle}
                  />
                </div>
              </div>

              {/* Apellido input */}
              <div style={inputContainerStyle}>
                <div style={inputWrapperStyle}>
                  <input
                    className="login-input"
                    type="text"
                    placeholder="Apellido"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    style={inputStyle}
                  />
                </div>
              </div>

              {/* Número de Documento input */}
              <div style={inputContainerStyle}>
                <div style={inputWrapperStyle}>
                  <input
                    className="login-input"
                    type="text"
                    placeholder="Número de Documento"
                    value={docNumber}
                    onChange={(e) => setDocNumber(e.target.value)}
                    style={inputStyle}
                  />
                </div>
              </div>

              {/* Confirm Password input */}
              <div style={inputContainerStyle}>
                <div style={inputWrapperStyle}>
                  <input
                    className="login-input"
                    type={showConfirmPassword ? "text" : "password"}
                    placeholder="Repita Contraseña"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    style={inputStyle}
                  />
                  {showConfirmPassword ? (
                    <img src={OpenEyeImg} alt="Ocultar contraseña" style={{ width: 20, height: 20, cursor: "pointer", flexShrink: 0 }} onClick={() => setShowConfirmPassword(false)} />
                  ) : (
                    <img src={CloseEyeImg} alt="Mostrar contraseña" style={{ width: 20, height: 20, cursor: "pointer", flexShrink: 0 }} onClick={() => setShowConfirmPassword(true)} />
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Alert */}
          {registerStatusAlert && <div style={{ width: "100%", marginBottom: 16 }}>{registerStatusAlert}</div>}

          {/* Register button - outside the box */}
          <div style={{ width: "100%", display: "flex", justifyContent: "center", marginBottom: 30 }}>
            <button
              type="button"
              className="register-btn"
              onClick={register}
              disabled={loading}
              style={{
                padding: "14px",
                background: "#004890",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                fontSize: 16,
                fontWeight: 600,
                cursor: loading ? "not-allowed" : "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
              }}
            >
              {loading ? <Spinner size="sm" color="white" /> : "Registrarse"}
            </button>
          </div>

          {/* Login link */}
          <p style={{ color: "#666", fontSize: 14 }}>
            Ya tenes cuenta?{" "}
            <Link to="/" style={{ color: "#06ACCD", fontWeight: "bold" }}>Ingresá</Link>
          </p>
            </>
          )}
        </div>

        {/* Footer */}
        <div style={{ textAlign: "center", padding: "20px 0", fontSize: 13, color: "#999", display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
          <img src={LogoFooterImg} alt="Hospital Británico" style={{ height: 14, width: 35 }} />
          <span>Hospital Británico | © 2025</span>
        </div>
      </div>

      {/* Right side - Image */}
      {showImagePanel && (
        <div style={{ flex: 1, position: "relative", overflow: "hidden", display: "flex", flexDirection: "column" }}>
          <img
            src={BGLogin}
            alt="Portal de prestadores"
            style={{ width: "100%", height: "100%", position: "fixed" }}
          />
          <div
            style={{
              position: "absolute",
              bottom: 150,
              left: 0,
              right: 0,
              background: "linear-gradient(180deg, #020A14,#395D84 )",
              padding: "40px 50px",
              color: "#fff",
              textAlign: "center",
              opacity: 0.6,
            }}
          >
            <h2 style={{ fontWeight: 600, fontSize: "39.84px", lineHeight: "48px", letterSpacing: 0, textAlign: "center", color: "#FFFFFF", marginBottom: 10 }}>
              Bienvenido al portal de <br /> prestadores
            </h2>
            <p style={{ fontWeight: 600, fontSize: "19.84px", lineHeight: "24px", letterSpacing: "0%", textAlign: "center", verticalAlign: "middle", opacity: 0.9 }}>
              Donde podrás Realiza tus tramites y gestiones online
              <br />
              de manera sencilla.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default RegisterPage;
